import React from "react";
import "./styles/brands.css";

const Brands = () => {
  return (
    <div className="container brands-main">
      <div className="brands-container">
      <div className="divider-brand">
        <img src="images/1.png" alt="" />
        <img src="images/6.png" style={{transform:"scale(1.4)"}} alt="" />
        <img src="images/3.png" alt="" />
        </div>
      </div>

      <div className="brands-container brands-container-2">
      <div className="divider-brand">
        <img src="images/5.png" alt="" />
        {/* <img style={{transform:"scale(1.4)"}} src="images/8.png" alt="" /> */}
        <img src="images/4.png" alt="" />
        <img src="images/2.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Brands;
